module.exports = __webpack_public_path__ + "static/img/feature6.c9bee5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/feature6.png
// module id = 0agY
// module chunks = 7